/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */


document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});

/* ================================
   LANGUAGE SWITCHER – Definitieve versie met 2-letter codes
   Zet dit NA je HTML van de language switch en NA het laden van element.js
==================================*/

/* Configuratie */
const GT_CONFIG = {
  sourceLang: 'nl',                 // brontaal van je site
  defaultTargetLang: 'en',          // doeltaal voor eerste bezoek
  autoTranslateOnFirstVisit: false   // zet uit als je nooit auto EN wilt
};

/* Elements */
const btn  = document.getElementById('langBtn');
const menu = document.getElementById('langMenu');

/* Cookie helpers */
function setCookie(name, value, days, path = '/', domain) {
  const d = new Date();
  d.setTime(d.getTime() + days*24*60*60*1000);
  const expires = '; expires=' + d.toUTCString();
  const domainPart = domain ? '; domain=' + domain : '';
  document.cookie = name + '=' + value + expires + '; path=' + path + domainPart;
}
function deleteCookieEverywhere(name) {
  setCookie(name, '', -1, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, '', -1, '/', '.' + host);
}
function setCookieEverywhere(name, value, days) {
  setCookie(name, value, days, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, value, days, '/', '.' + host);
}
function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1') + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

/* Google Translate helpers */
function clearGTCookies() { deleteCookieEverywhere('googtrans'); }
function setGTCookiePath(from, to) { setCookieEverywhere('googtrans', `/${from}/${to}`, 365); }

/* Huidige taal uit cookie */
function getCurrentLangFromCookie() {
  const v = getCookie('googtrans');
  if (v && v.split('/')[2]) return v.split('/')[2];
  return GT_CONFIG.sourceLang;
}

/* Label knop zetten (altijd 2-letter code, of bijv. ZH-CN → ZH) */
function setButtonLabelByLang(lang) {
  if (!btn) return;
  const shortCode = lang.split('-')[0].toUpperCase();
  btn.textContent = shortCode + ' ˅';
}

/* Taal toepassen */
function applyLanguage(lang) {
  const select = document.querySelector('#google_translate_element select.goog-te-combo');

  if (lang === GT_CONFIG.sourceLang) {
    // Bewust terug naar brontaal
    sessionStorage.setItem('manualNLReset', '1');
    setCookieEverywhere('forceNL', 'true', 365);
    clearGTCookies();

    // Reset mogelijke Google state
    const frame = document.querySelector('iframe.goog-te-banner-frame');
    if (frame) frame.remove();

    location.reload();
    return;
  }

  // Naar een andere taal: forceNL wissen, cookie (en evt. select) zetten
  deleteCookieEverywhere('forceNL');

  if (select) {
    select.value = lang;
    select.dispatchEvent(new Event('change'));
  } else {
    setGTCookiePath(GT_CONFIG.sourceLang, lang);
    location.reload();
  }
}

/* Alleen dropdown functionaliteit als elementen bestaan */
if (btn && menu) {
  /* Dropdown open/dicht */
  btn.addEventListener('click', () => {
    const open = menu.hasAttribute('hidden') === false;
    if (open) {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      menu.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
  
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.lang-switch')) {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  /* Klikken op custom menu */
  menu.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-lang]');
    if (!li) return;
    const lang = li.getAttribute('data-lang');
    applyLanguage(lang);

    setButtonLabelByLang(lang);
    menu.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
  });

  /* Init knoplabel bij laden */
  function initLabel() {
    const forceNL = getCookie('forceNL') === 'true';
    const lang = forceNL ? GT_CONFIG.sourceLang : getCurrentLangFromCookie();
    setButtonLabelByLang(lang);

    // fallback als select later inlaadt
    const select = document.querySelector('#google_translate_element select.goog-te-combo');
    if (!select) setTimeout(initLabel, 300);
  }
  initLabel();
}

/* Automatisch vertalen op eerste bezoek, afhankelijk van config */
(function autoTranslateFirstVisit() {
  if (!GT_CONFIG.autoTranslateOnFirstVisit) return;

  const desiredPath = `/${GT_CONFIG.sourceLang}/${GT_CONFIG.defaultTargetLang}`;
  const hasGoogTrans = !!getCookie('googtrans');
  const manualReset  = sessionStorage.getItem('manualNLReset') === '1';
  const forceNL      = getCookie('forceNL') === 'true';

  if (!hasGoogTrans && !manualReset && !forceNL) {
    setCookieEverywhere('googtrans', desiredPath, 365);
  } else if (manualReset) {
    sessionStorage.removeItem('manualNLReset');
  }
})();




/* KAVELKIEZER V3 */
(function() {
    'use strict';

    // Check of de kavelkiezer op deze pagina aanwezig is
    const mapViewsContainer = document.getElementById('mapViews');
    if (!mapViewsContainer) {
        // Kavelkiezer niet op deze pagina, stop uitvoering
        return;
    }

    const wrapper = document.getElementById('mapWrapper');
    const svg = document.getElementById('kavelSvg');
    const bgImg = document.getElementById('mapCanvas');
    const tooltip = document.getElementById('kavelTooltip');
    const panel = document.getElementById('detailsPanel');
    const overlayBg = document.getElementById('overlayBg');
    const mapContainer = document.querySelector('.map-container');

    // Extra check op essentiële elementen
    if (!wrapper || !svg || !bgImg || !tooltip || !panel || !overlayBg || !mapContainer) {
        console.warn('Kavelkiezer: Niet alle required elementen aanwezig op deze pagina');
        return;
    }

    const viewMapBtn = document.getElementById('viewMapBtn');
    const viewListBtn = document.getElementById('viewListBtn');
    const viewMapBtnMobile = document.getElementById('viewMapBtnMobile');
    const viewListBtnMobile = document.getElementById('viewListBtnMobile');
    const pricelistContainer = document.getElementById('pricelistContainer');
    const pricelistBody = document.getElementById('pricelistBody');
    const pricelistEmpty = document.getElementById('pricelistEmpty');

    const filterStatus = document.getElementById('filterStatus');
    const filterType = document.getElementById('filterType');
    const filterModel = document.getElementById('filterModel');
    const filterBedrooms = document.getElementById('filterBedrooms');
    const resetBtn = document.getElementById('resetFilters');
    const resultsCounter = document.getElementById('resultsCounter');
    const mobileResultsCounter = document.getElementById('mobileResultsCounter');

    const mobileFilterBtn = document.getElementById('mobileFilterBtn');
    const mobileFilterBadge = document.getElementById('mobileFilterBadge');
    const filterDrawer = document.getElementById('filterDrawer');
    const filterDrawerOverlay = document.getElementById('filterDrawerOverlay');
    const filterDrawerClose = document.getElementById('filterDrawerClose');
    const filterDrawerReset = document.getElementById('filterDrawerReset');
    const filterDrawerApply = document.getElementById('filterDrawerApply');
    const filterStatusMobile = document.getElementById('filterStatusMobile');
    const filterTypeMobile = document.getElementById('filterTypeMobile');
    const filterModelMobile = document.getElementById('filterModelMobile');
    const filterBedroomsMobile = document.getElementById('filterBedroomsMobile');

    const moreFiltersBtn = document.getElementById('moreFiltersBtn');
    const moreFiltersDropdown = document.getElementById('moreFiltersDropdown');
    const moreFiltersBadge = document.getElementById('moreFiltersBadge');
    const filterModelDropdown = document.getElementById('filterModelDropdown');
    const filterBedroomsDropdown = document.getElementById('filterBedroomsDropdown');

    const viewSelect = document.getElementById('viewSelect');
    const viewPrev = document.getElementById('viewPrev');
    const viewNext = document.getElementById('viewNext');

    // Read data from HTML
    const mapViews = Array.from(mapViewsContainer.querySelectorAll('.map-view'));
    const views = mapViews.map((view, index) => ({
        index: index,
        id: view.dataset.id,
        label: view.dataset.label,
        background: view.dataset.background,
        viewBox: view.dataset.vb || '0 0 1920 1080'
    }));

    views.forEach((view, index) => {
        const option = document.createElement('option');
        option.value = index;
        option.textContent = view.label;
        viewSelect.appendChild(option);
    });

    // Helpers
    function parsePrice(priceStr) {
        if (!priceStr) return 0;
        const match = priceStr.match(/€?\s*([\d.,]+)/);
        if (!match) return 0;
        return parseInt(match[1].replace(/[^\d]/g, '')) || 0;
    }

    function parseM2(m2Str) {
        if (!m2Str) return 0;
        const match = m2Str.match(/(\d+)/);
        return match ? parseInt(match[1]) : 0;
    }

    function formatPriceShort(val) {
        if (val >= 1000000) return '€' + (val / 1000000).toFixed(1) + 'M';
        return '€' + Math.round(val / 1000) + 'k';
    }

    // Zet data-status om naar een CSS-vriendelijke key (lowercase, spaties naar koppelteken)
    // Elke status heeft zijn eigen kleur — geen groepering meer nodig
    function statusToKey(status) {
        if (!status) return 'toekomstig';
        return status.toLowerCase().trim().replace(/\s+/g, '-');
    }

    function statusToLabel(status) {
        if (!status) return 'Toekomstig';
        const s = status.toLowerCase().trim();
        const map = {
            'available':                    'Beschikbaar',
            'beschikbaar':                  'Beschikbaar',
            'vrij':                         'Beschikbaar',
            'te-koop':                      'Te koop',
            'te koop':                      'Te koop',
            'option':                       'Onder optie',
            'optie':                        'Onder optie',
            'onder-optie':                  'Onder optie',
            'onder optie':                  'Onder optie',
            'in-optie':                     'Onder optie',
            'in optie':                     'Onder optie',
            'onder-bod':                    'Onder bod',
            'onder bod':                    'Onder bod',
            'oral-agreement':               'Mondeling verkocht',
            'mondeling-verkocht':           'Mondeling verkocht',
            'mondeling verkocht':           'Mondeling verkocht',
            'verhuurd':                     'Verhuurd',
            'verhuurd-onder-voorbehoud':    'Verhuurd o.v.',
            'verhuurd onder voorbehoud':    'Verhuurd o.v.',
            'sold':                         'Verkocht',
            'verkocht':                     'Verkocht',
            'verkoht':                      'Verkocht',
            'verkocht-onder-voorbehoud':    'Verkocht o.v.',
            'verkocht onder voorbehoud':    'Verkocht o.v.',
            'future':                       'Toekomstig',
            'toekomstig':                   'Toekomstig',
            'in-aanmelding':                'In aanmelding',
            'in aanmelding':                'In aanmelding',
            'nog-niet-in-verkoop':          'Nog niet in verkoop',
            'nog niet in verkoop':          'Nog niet in verkoop',
            'binnenkort':                   'Binnenkort',
        };
        return map[s] || status;
    }

    // CSS klasse voor Bootstrap badges in het details panel
    function statusToBadgeClass(status) {
        const k = statusToKey(status);
        const map = {
            'available':                    'bg-success',
            'beschikbaar':                  'bg-success',
            'vrij':                         'bg-success',
            'te-koop':                      'bg-success',
            'option':                       'bg-warning text-dark',
            'optie':                        'bg-warning text-dark',
            'onder-optie':                  'bg-warning text-dark',
            'in-optie':                     'bg-warning text-dark',
            'onder-bod':                    'bg-warning text-dark',
            'oral-agreement':               'bg-oral-agreement',
            'mondeling-verkocht':           'bg-oral-agreement',
            'verhuurd':                     'bg-rented',
            'verhuurd-onder-voorbehoud':    'bg-rented',
            'sold':                         'bg-danger',
            'verkocht':                     'bg-danger',
            'verkoht':                      'bg-danger',
            'verkocht-onder-voorbehoud':    'bg-sold-option',
        };
        return map[k] || 'bg-future';
    }

    // CSS klasse voor de tooltip badge
    function statusToTooltipBadge(status) {
        const k = statusToKey(status);
        const map = {
            'available':                    'bg-available',
            'beschikbaar':                  'bg-available',
            'vrij':                         'bg-available',
            'te-koop':                      'bg-available',
            'option':                       'bg-option',
            'optie':                        'bg-option',
            'onder-optie':                  'bg-option',
            'in-optie':                     'bg-option',
            'onder-bod':                    'bg-option',
            'oral-agreement':               'bg-oral-agreement',
            'mondeling-verkocht':           'bg-oral-agreement',
            'verhuurd':                     'bg-rented',
            'verhuurd-onder-voorbehoud':    'bg-rented',
            'sold':                         'bg-sold',
            'verkocht':                     'bg-sold',
            'verkoht':                      'bg-sold',
            'verkocht-onder-voorbehoud':    'bg-sold-option',
        };
        return map[k] || 'bg-future';
    }

    // Analyze data
    function analyzeKavelData() {
        const statuses = new Set(), types = new Set(), models = new Set(), bedrooms = new Set();
        let minPrice = Infinity, maxPrice = 0, minM2 = Infinity, maxM2 = 0, minPerceel = Infinity, maxPerceel = 0, totalKavels = 0;
        const seenIds = new Set();

        mapViews.forEach(view => {
            view.querySelectorAll('path').forEach(path => {
                const id = path.dataset.id;
                if (seenIds.has(id)) return;
                seenIds.add(id);
                totalKavels++;

                const status = statusToKey(path.dataset.status);
                if (status) statuses.add(status);
                if (path.dataset.naam) types.add(path.dataset.naam);
                if (path.dataset.typewoning) models.add(path.dataset.typewoning);

                const bedroom = path.dataset.aantalKamers || path.dataset.aantalSlaapkamers;
                if (bedroom) { const num = bedroom.replace(/[^\d]/g, ''); if (num) bedrooms.add(num); }

                const price = parsePrice(path.dataset.prijs);
                if (price > 0) { minPrice = Math.min(minPrice, price); maxPrice = Math.max(maxPrice, price); }

                const m2 = parseM2(path.dataset.woonoppervlakte);
                if (m2 > 0) { minM2 = Math.min(minM2, m2); maxM2 = Math.max(maxM2, m2); }

                const perceel = parseM2(path.dataset.perceeloppervlakte);
                if (perceel > 0) { minPerceel = Math.min(minPerceel, perceel); maxPerceel = Math.max(maxPerceel, perceel); }
            });
        });

        if (minPrice === Infinity) minPrice = 0;
        if (minM2 === Infinity) minM2 = 0;
        if (minPerceel === Infinity) minPerceel = 0;

        return {
            statuses: Array.from(statuses),
            types: Array.from(types).sort(),
            models: Array.from(models).sort(),
            bedrooms: Array.from(bedrooms).sort((a, b) => parseInt(a) - parseInt(b)),
            priceRange: { min: minPrice, max: maxPrice },
            m2Range: { min: minM2, max: maxM2 },
            perceelRange: { min: minPerceel, max: maxPerceel },
            totalKavels
        };
    }

    const kavelData = analyzeKavelData();

    // Setup filters
    function setFilterVisible(elementId, visible) {
        const el = document.getElementById(elementId);
        if (el) el.classList.toggle('filter-hidden', !visible);
    }

    function setupFilters() {
        const { statuses, types, models, bedrooms, priceRange: priceData, m2Range: m2Data, perceelRange: perceelData, totalKavels } = kavelData;

        const showStatusFilter = totalKavels > 0 && statuses.length > 1;
        setFilterVisible('filterStatusWrap', showStatusFilter);
        setFilterVisible('filterStatusMobileWrap', showStatusFilter);

        if (showStatusFilter) {
            const statusOrder = ['available', 'option', 'oral-agreement', 'rented', 'sold', 'future'];
            const sorted = statuses.sort((a, b) => statusOrder.indexOf(a) - statusOrder.indexOf(b));
            [filterStatus, filterStatusMobile].forEach(sel => {
                sorted.forEach(st => { const opt = document.createElement('option'); opt.value = st; opt.textContent = statusToLabel(st); sel.appendChild(opt); });
            });
        }

        const showTypeFilter = totalKavels > 0 && types.length > 1;
        setFilterVisible('filterTypeWrap', showTypeFilter);
        setFilterVisible('filterTypeMobileWrap', showTypeFilter);
        if (showTypeFilter) {
            [filterType, filterTypeMobile].forEach(sel => {
                types.forEach(t => { const opt = document.createElement('option'); opt.value = t.toLowerCase(); opt.textContent = t; sel.appendChild(opt); });
            });
        }

        const showModelFilter = totalKavels > 0 && models.length > 1;
        setFilterVisible('filterModelWrap', showModelFilter);
        setFilterVisible('filterModelMobileWrap', showModelFilter);
        setFilterVisible('filterModelWrapDropdown', showModelFilter);
        if (showModelFilter) {
            [filterModel, filterModelMobile, filterModelDropdown].forEach(sel => {
                if (!sel) return;
                models.forEach(m => { const opt = document.createElement('option'); opt.value = m; opt.textContent = m; sel.appendChild(opt); });
            });
        }

        const showBedroomsFilter = totalKavels > 0 && bedrooms.length > 1;
        setFilterVisible('filterBedroomsWrap', showBedroomsFilter);
        setFilterVisible('filterBedroomsMobileWrap', showBedroomsFilter);
        setFilterVisible('filterBedroomsWrapDropdown', showBedroomsFilter);
        if (showBedroomsFilter) {
            [filterBedrooms, filterBedroomsMobile, filterBedroomsDropdown].forEach(sel => {
                if (!sel) return;
                bedrooms.forEach(b => { const opt = document.createElement('option'); opt.value = b; opt.textContent = b + ' slaapkamer' + (parseInt(b) !== 1 ? 's' : ''); sel.appendChild(opt); });
            });
        }

        const showPriceFilter = totalKavels > 0 && priceData.max > 0 && priceData.min < priceData.max;
        setFilterVisible('filterPriceWrap', showPriceFilter);
        setFilterVisible('filterPriceMobileWrap', showPriceFilter);

        const showM2Filter = totalKavels > 0 && m2Data.max > 0 && m2Data.min < m2Data.max;
        setFilterVisible('filterM2Wrap', showM2Filter);
        setFilterVisible('filterM2MobileWrap', showM2Filter);
        setFilterVisible('filterM2WrapDropdown', showM2Filter);

        const showPerceelFilter = totalKavels > 0 && perceelData.max > 0 && perceelData.min < perceelData.max;
        setFilterVisible('filterPerceelWrap', showPerceelFilter);
        setFilterVisible('filterPerceelMobileWrap', showPerceelFilter);
        setFilterVisible('filterPerceelWrapDropdown', showPerceelFilter);

        return { showPriceFilter, showM2Filter, showPerceelFilter, priceData, m2Data, perceelData };
    }

    const filterConfig = setupFilters();

    // State
    let activeStatusFilter = '', activeTypeFilter = '', activeModelFilter = '', activeBedroomsFilter = '';
    let activeView = 'map', sortColumn = 'bouwnummer', sortDirection = 'asc', isInitialized = false;

    const priceMin = filterConfig.showPriceFilter ? Math.floor(filterConfig.priceData.min / 10000) * 10000 : 200000;
    const priceMax = filterConfig.showPriceFilter ? Math.ceil(filterConfig.priceData.max / 10000) * 10000 : 1000000;
    const m2Min = filterConfig.showM2Filter ? Math.floor(filterConfig.m2Data.min / 5) * 5 : 40;
    const m2Max = filterConfig.showM2Filter ? Math.ceil(filterConfig.m2Data.max / 5) * 5 : 200;
    const perceelMin = filterConfig.showPerceelFilter ? Math.floor(filterConfig.perceelData.min / 10) * 10 : 100;
    const perceelMax = filterConfig.showPerceelFilter ? Math.ceil(filterConfig.perceelData.max / 10) * 10 : 500;

    let priceRange = [priceMin, priceMax], m2Range = [m2Min, m2Max], perceelRange = [perceelMin, perceelMax];
    let isOpen = false, pinnedId = null, currentViewIndex = 0, scale = 1, panX = 0, panY = 0;
    const MIN_SCALE = 1, MAX_SCALE = 5;

    // Dual range sliders
    function createSlider(container, start, range, step, onUpdate) {
        if (!container) return null;
        const min = range.min, max = range.max;
        let values = [start[0], start[1]];
        const changeCallbacks = [];

        container.innerHTML = `<div class="dual-range-slider"><div class="dual-range-track"></div><div class="dual-range-fill"></div><input type="range" class="range-min" min="${min}" max="${max}" step="${step}" value="${start[0]}"><input type="range" class="range-max" min="${min}" max="${max}" step="${step}" value="${start[1]}"></div>`;

        const slider = container.querySelector('.dual-range-slider');
        const fill = slider.querySelector('.dual-range-fill');
        const rangeMin = slider.querySelector('.range-min');
        const rangeMax = slider.querySelector('.range-max');

        function updateFill() {
            const minP = ((values[0] - min) / (max - min)) * 100;
            const maxP = ((values[1] - min) / (max - min)) * 100;
            fill.style.left = minP + '%';
            fill.style.width = (maxP - minP) + '%';
        }

        rangeMin.addEventListener('input', () => {
            const minV = parseInt(rangeMin.value), maxV = parseInt(rangeMax.value);
            if (minV > maxV - step) { rangeMin.value = maxV - step; values[0] = maxV - step; } else { values[0] = minV; }
            updateFill(); onUpdate([values[0], values[1]]);
        });

        rangeMax.addEventListener('input', () => {
            const minV = parseInt(rangeMin.value), maxV = parseInt(rangeMax.value);
            if (maxV < minV + step) { rangeMax.value = minV + step; values[1] = minV + step; } else { values[1] = maxV; }
            updateFill(); onUpdate([values[0], values[1]]);
        });

        rangeMin.addEventListener('change', () => changeCallbacks.forEach(cb => cb([values[0], values[1]])));
        rangeMax.addEventListener('change', () => changeCallbacks.forEach(cb => cb([values[0], values[1]])));

        updateFill(); onUpdate([values[0], values[1]]);

        return {
            get: () => [values[0], values[1]],
            set: (nv) => { values[0] = nv[0]; values[1] = nv[1]; rangeMin.value = values[0]; rangeMax.value = values[1]; updateFill(); onUpdate([values[0], values[1]]); },
            on: (ev, cb) => { if (ev === 'change') changeCallbacks.push(cb); }
        };
    }

    let priceSlider = null, priceSliderMobile = null, m2Slider = null, m2SliderMobile = null, perceelSlider = null, perceelSliderMobile = null;

    if (filterConfig.showPriceFilter) {
        priceSlider = createSlider(document.getElementById('priceSlider'), [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, (v) => { priceRange = v.map(Number); document.getElementById('priceValue').textContent = formatPriceShort(priceRange[0]) + ' - ' + formatPriceShort(priceRange[1]); applyFilters(); });
        priceSliderMobile = createSlider(document.getElementById('priceSliderMobile'), [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, (v) => { document.getElementById('priceValueMobile').textContent = '€ ' + Number(v[0]).toLocaleString('nl-NL') + ' - € ' + Number(v[1]).toLocaleString('nl-NL'); });
    }

    if (filterConfig.showM2Filter) {
        m2Slider = createSlider(document.getElementById('m2Slider'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, (v) => { m2Range = v.map(Number); document.getElementById('m2Value').textContent = m2Range[0] + ' - ' + m2Range[1] + ' m²'; applyFilters(); });
        m2SliderMobile = createSlider(document.getElementById('m2SliderMobile'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, (v) => { document.getElementById('m2ValueMobile').textContent = v[0] + ' - ' + v[1] + ' m²'; });
    }

    if (filterConfig.showPerceelFilter) {
        perceelSlider = createSlider(document.getElementById('perceelSlider'), [perceelMin, perceelMax], { min: perceelMin, max: perceelMax }, 10, (v) => { perceelRange = v.map(Number); document.getElementById('perceelValue').textContent = perceelRange[0] + ' - ' + perceelRange[1] + ' m²'; applyFilters(); });
        perceelSliderMobile = createSlider(document.getElementById('perceelSliderMobile'), [perceelMin, perceelMax], { min: perceelMin, max: perceelMax }, 10, (v) => { document.getElementById('perceelValueMobile').textContent = v[0] + ' - ' + v[1] + ' m²'; });
    }

    let m2SliderDropdown = null, perceelSliderDropdown = null;
    if (filterConfig.showM2Filter) {
        m2SliderDropdown = createSlider(document.getElementById('m2SliderDropdown'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, (v) => { m2Range = v.map(Number); document.getElementById('m2ValueDropdown').textContent = v[0] + ' - ' + v[1] + ' m²'; if (m2Slider) m2Slider.set(m2Range); applyFilters(); });
    }
    if (filterConfig.showPerceelFilter) {
        perceelSliderDropdown = createSlider(document.getElementById('perceelSliderDropdown'), [perceelMin, perceelMax], { min: perceelMin, max: perceelMax }, 10, (v) => { perceelRange = v.map(Number); document.getElementById('perceelValueDropdown').textContent = v[0] + ' - ' + v[1] + ' m²'; if (perceelSlider) perceelSlider.set(perceelRange); applyFilters(); });
    }

    // Render view
    function renderView(viewIndex) {
        const view = views[viewIndex], viewEl = mapViews[viewIndex];
        if (!view || !viewEl) return;
        bgImg.src = view.background;
        if (view.viewBox && view.viewBox.trim()) {
            svg.setAttribute('viewBox', view.viewBox);
            const vbParts = view.viewBox.split(' ').map(Number);
            if (vbParts.length === 4) {
                const vbWidth = vbParts[2], vbHeight = vbParts[3];
                wrapper.style.aspectRatio = vbWidth + ' / ' + vbHeight;
            }
        }

        svg.innerHTML = '';
        viewEl.querySelectorAll('path').forEach(p => {
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            Array.from(p.attributes).forEach(attr => {
                path.setAttribute(attr.name, attr.value);
            });
            svg.appendChild(path);
        });

        // Altijd de juiste status-class zetten op basis van data-status
        // (overschrijft eventueel foutieve hardcoded classes in de HTML)
        svg.querySelectorAll('.hover-area').forEach(path => {
            // Verwijder alle bestaande status-* classes
            Array.from(path.classList)
                .filter(c => c.startsWith('status-'))
                .forEach(c => path.classList.remove(c));
            // Zet de correcte status class op basis van data-status
            const key = statusToKey(path.dataset.status);
            path.classList.add('status-' + key);
        });

        scale = 1; panX = 0; panY = 0;
        applyTransform();
        svg.classList.remove('has-selection');
        applyFilters();
    }

    // Get all kavels
    function getAllKavels() {
        const kavels = [], seenIds = new Set();
        mapViews.forEach(view => {
            view.querySelectorAll('path').forEach(path => {
                const id = path.dataset.id;
                if (seenIds.has(id)) return;
                seenIds.add(id);
                const kamers = path.dataset.aantalKamers || path.dataset.aantalSlaapkamers || '';
                kavels.push({
                    id, bouwnummer: path.dataset.bouwnummer || '', naam: path.dataset.naam || '', typewoning: path.dataset.typewoning || '',
                    prijs: path.dataset.prijs || '', prijsNum: parsePrice(path.dataset.prijs), status: statusToKey(path.dataset.status),
                    woonoppervlakte: path.dataset.woonoppervlakte || '', woonoppervlakteNum: parseM2(path.dataset.woonoppervlakte),
                    perceeloppervlakte: path.dataset.perceeloppervlakte || '', perceeloppervlakteNum: parseM2(path.dataset.perceeloppervlakte),
                    buitenruimte: path.dataset.buitenruimte || '', verdieping: path.dataset.verdieping || '', aantalKamers: kamers,
                    ligging: path.dataset.ligging || '', afbeelding: path.dataset.afbeelding || '', info: path.dataset.info || '', woonlastenUrl: path.dataset.woonlastenUrl || ''
                });
            });
        });
        return kavels;
    }
    const allKavels = getAllKavels();

    // Filter matching
    function kavelMatchesFilters(k) {
        if (activeStatusFilter && k.status !== activeStatusFilter) return false;
        if (activeTypeFilter && k.naam.toLowerCase() !== activeTypeFilter) return false;
        if (activeModelFilter && k.typewoning !== activeModelFilter) return false;
        if (activeBedroomsFilter && k.aantalKamers.replace(/[^\d]/g, '') !== activeBedroomsFilter) return false;
        if (filterConfig.showPriceFilter && k.prijsNum > 0 && (k.prijsNum < priceRange[0] || k.prijsNum > priceRange[1])) return false;
        if (filterConfig.showM2Filter && k.woonoppervlakteNum > 0 && (k.woonoppervlakteNum < m2Range[0] || k.woonoppervlakteNum > m2Range[1])) return false;
        if (filterConfig.showPerceelFilter && k.perceeloppervlakteNum > 0 && (k.perceeloppervlakteNum < perceelRange[0] || k.perceeloppervlakteNum > perceelRange[1])) return false;
        return true;
    }

    // Apply filters
    function applyFilters() {
        let ac = 0;
        if (activeStatusFilter) ac++; if (activeTypeFilter) ac++; if (activeModelFilter) ac++; if (activeBedroomsFilter) ac++;
        if (filterConfig.showPriceFilter && (priceRange[0] > priceMin || priceRange[1] < priceMax)) ac++;
        if (filterConfig.showM2Filter && (m2Range[0] > m2Min || m2Range[1] < m2Max)) ac++;
        if (filterConfig.showPerceelFilter && (perceelRange[0] > perceelMin || perceelRange[1] < perceelMax)) ac++;
        mobileFilterBadge.textContent = ac || ''; mobileFilterBadge.dataset.count = ac;

        let mc = 0;
        if (activeModelFilter) mc++; if (activeBedroomsFilter) mc++;
        if (filterConfig.showM2Filter && (m2Range[0] > m2Min || m2Range[1] < m2Max)) mc++;
        if (filterConfig.showPerceelFilter && (perceelRange[0] > perceelMin || perceelRange[1] < perceelMax)) mc++;
        moreFiltersBadge.textContent = mc || ''; moreFiltersBadge.dataset.count = mc;

        let visibleCount = 0;
        svg.querySelectorAll('.hover-area').forEach(el => {
            const kamers = el.dataset.aantalKamers || el.dataset.aantalSlaapkamers || '';
            const k = { status: statusToKey(el.dataset.status), naam: el.dataset.naam || '', typewoning: el.dataset.typewoning || '', aantalKamers: kamers, prijsNum: parsePrice(el.dataset.prijs), woonoppervlakteNum: parseM2(el.dataset.woonoppervlakte), perceeloppervlakteNum: parseM2(el.dataset.perceeloppervlakte) };
            const m = kavelMatchesFilters(k);
            el.classList.toggle('is-dimmed', !m);
            if (m) visibleCount++;
        });

        let plVisibleCount = 0;
        pricelistBody.querySelectorAll('.pl-row').forEach(row => {
            const k = allKavels.find(x => x.id === row.dataset.id);
            if (k) { const m = kavelMatchesFilters(k); row.classList.toggle('is-dimmed', !m); if (m) plVisibleCount++; }
        });

        pricelistEmpty.style.display = plVisibleCount === 0 ? 'block' : 'none';
        const cnt = activeView === 'map' ? visibleCount : plVisibleCount;
        resultsCounter.innerHTML = `<strong>${cnt}</strong> ${cnt === 1 ? 'woning' : 'woningen'}`;
        mobileResultsCounter.innerHTML = `<strong>${cnt}</strong> ${cnt === 1 ? 'woning' : 'woningen'}`;

        if (pinnedId) { const pe = svg.querySelector(`[data-id="${pinnedId}"]`); if (pe && pe.classList.contains('is-dimmed')) closePanel(); }
        if (isInitialized) updateUrlParams();
    }

    // Pricelist
    function renderPricelist() {
        const plContainer = document.querySelector('.pricelist-container');
        if (plContainer) plContainer.classList.toggle('hide-perceel', !filterConfig.showPerceelFilter);

        const sorted = [...allKavels].sort((a, b) => {
            let vA, vB;
            switch (sortColumn) {
                case 'bouwnummer': return sortDirection === 'asc' ? a.bouwnummer.localeCompare(b.bouwnummer, 'nl', { numeric: true }) : b.bouwnummer.localeCompare(a.bouwnummer, 'nl', { numeric: true });
                case 'type': vA = a.naam + ' ' + a.typewoning; vB = b.naam + ' ' + b.typewoning; break;
                case 'woonoppervlakte': vA = a.woonoppervlakteNum; vB = b.woonoppervlakteNum; break;
                case 'perceeloppervlakte': vA = a.perceeloppervlakteNum; vB = b.perceeloppervlakteNum; break;
                case 'prijs': vA = a.prijsNum; vB = b.prijsNum; break;
                default: vA = a.bouwnummer; vB = b.bouwnummer;
            }
            if (typeof vA === 'string') return sortDirection === 'asc' ? vA.localeCompare(vB) : vB.localeCompare(vA);
            return sortDirection === 'asc' ? vA - vB : vB - vA;
        });

        let html = '';
        sorted.forEach(k => {
            const wl = k.woonlastenUrl ? `<div class="lot-meta"><i class="fa fa-calculator me-2"></i><a href="${k.woonlastenUrl}" target="_blank">Wat zijn mijn woonlasten?</a></div>` : '';
            html += `<div class="pl-row" data-id="${k.id}"><div class="pl-row-header"><div class="pl-grid"><div>${k.bouwnummer}</div><div>${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</div><div class="pl-col-woonopp">${k.woonoppervlakte}</div><div class="pl-col-perceel">${k.perceeloppervlakte || '-'}</div><div>${k.prijs}</div><div class="pl-status"><span class="pl-status-dot status-${k.status}"></span><span>${statusToLabel(k.status)}</span></div><div class="pl-col-arrow"><i class="fa fa-chevron-right"></i></div></div></div><div class="pl-row-panel"><div class="lot-panel status-${k.status}"><div class="lot-panel-inner"><div class="lot-media"><img src="${k.afbeelding}" alt="${k.naam} ${k.bouwnummer}" loading="lazy"></div><div class="lot-body"><div class="lot-head"><div><div class="lot-number">Bouwnummer ${k.bouwnummer}</div><h3 class="lot-title">${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</h3></div><div class="lot-price">${k.prijs}</div></div><div class="lot-chips">${k.woonoppervlakte ? `<span class="lot-chip" title="${k.woonoppervlakte} woonoppervlakte"><i class="fa fa-ruler-combined me-1"></i>${k.woonoppervlakte}</span>` : ''}${k.perceeloppervlakte ? `<span class="lot-chip" title="${k.perceeloppervlakte} perceeloppervlakte"><i class="fa fa-vector-square me-1"></i>${k.perceeloppervlakte} perceel</span>` : ''}${k.aantalKamers ? `<span class="lot-chip" title="${k.aantalKamers} slaapkamer${k.aantalKamers !== '1' ? 's' : ''}"><i class="fa fa-bed me-1"></i>${k.aantalKamers}</span>` : ''}${k.buitenruimte ? `<span class="lot-chip" title="${k.buitenruimte} m² buitenruimte"><i class="fa fa-sun me-1"></i>${k.buitenruimte} m²</span>` : ''}${k.ligging ? `<span class="lot-chip" title="Ligging: ${k.ligging}"><i class="fa fa-compass me-1"></i>${k.ligging}</span>` : ''}</div><div class="lot-actions"><a class="btn btn-primary-kk" href="${k.info}" target="_blank">Bekijk meer details <i class="fa fa-arrow-right ms-2"></i></a></div>${wl}</div></div></div></div></div>`;
        });
        pricelistBody.innerHTML = html;
        pricelistBody.querySelectorAll('.pl-row-header').forEach(h => {
            h.addEventListener('click', () => { const r = h.closest('.pl-row'), w = r.classList.contains('is-expanded'); pricelistBody.querySelectorAll('.pl-row.is-expanded').forEach(x => x.classList.remove('is-expanded')); if (!w) r.classList.add('is-expanded'); });
        });
        applyFilters();
    }

    // Sort
    document.querySelectorAll('.pricelist-header .pl-col[data-sort]').forEach(col => {
        col.addEventListener('click', () => {
            const ns = col.dataset.sort;
            if (sortColumn === ns) sortDirection = sortDirection === 'asc' ? 'desc' : 'asc'; else { sortColumn = ns; sortDirection = 'asc'; }
            document.querySelectorAll('.pricelist-header .pl-col').forEach(c => { c.classList.remove('sort-active'); const i = c.querySelector('.sort-icon'); if (i) i.className = 'fa fa-sort sort-icon'; });
            col.classList.add('sort-active'); const ic = col.querySelector('.sort-icon'); if (ic) ic.className = `fa fa-sort-${sortDirection === 'asc' ? 'up' : 'down'} sort-icon`;
            renderPricelist();
        });
    });

    // View toggle
    function setActiveView(v) {
        activeView = v;
        viewMapBtn.classList.toggle('active', v === 'map'); viewListBtn.classList.toggle('active', v === 'list');
        viewMapBtnMobile.classList.toggle('active', v === 'map'); viewListBtnMobile.classList.toggle('active', v === 'list');
        mapContainer.style.display = v === 'map' ? '' : 'none';
        pricelistContainer.classList.toggle('is-active', v === 'list');
        applyFilters();
    }
    viewMapBtn.addEventListener('click', () => setActiveView('map'));
    viewListBtn.addEventListener('click', () => setActiveView('list'));
    viewMapBtnMobile.addEventListener('click', () => setActiveView('map'));
    viewListBtnMobile.addEventListener('click', () => setActiveView('list'));

    // Filter events
    filterStatus.addEventListener('change', () => { activeStatusFilter = filterStatus.value; applyFilters(); });
    filterType.addEventListener('change', () => { activeTypeFilter = filterType.value; applyFilters(); });
    filterModel.addEventListener('change', () => { activeModelFilter = filterModel.value; if (filterModelDropdown) filterModelDropdown.value = activeModelFilter; applyFilters(); });
    filterBedrooms.addEventListener('change', () => { activeBedroomsFilter = filterBedrooms.value; if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter; applyFilters(); });
    if (filterModelDropdown) filterModelDropdown.addEventListener('change', () => { activeModelFilter = filterModelDropdown.value; filterModel.value = activeModelFilter; applyFilters(); });
    if (filterBedroomsDropdown) filterBedroomsDropdown.addEventListener('change', () => { activeBedroomsFilter = filterBedroomsDropdown.value; filterBedrooms.value = activeBedroomsFilter; applyFilters(); });
    resetBtn.addEventListener('click', resetAllFilters);

    function resetAllFilters() {
        activeStatusFilter = ''; activeTypeFilter = ''; activeModelFilter = ''; activeBedroomsFilter = '';
        filterStatus.value = ''; filterType.value = ''; filterModel.value = ''; filterBedrooms.value = '';
        filterStatusMobile.value = ''; filterTypeMobile.value = ''; filterModelMobile.value = ''; filterBedroomsMobile.value = '';
        priceRange = [priceMin, priceMax]; m2Range = [m2Min, m2Max]; perceelRange = [perceelMin, perceelMax];
        if (priceSlider) priceSlider.set([priceMin, priceMax]); if (m2Slider) m2Slider.set([m2Min, m2Max]); if (perceelSlider) perceelSlider.set([perceelMin, perceelMax]);
        if (priceSliderMobile) priceSliderMobile.set([priceMin, priceMax]); if (m2SliderMobile) m2SliderMobile.set([m2Min, m2Max]); if (perceelSliderMobile) perceelSliderMobile.set([perceelMin, perceelMax]);
        if (filterModelDropdown) filterModelDropdown.value = ''; if (filterBedroomsDropdown) filterBedroomsDropdown.value = '';
        if (m2SliderDropdown) m2SliderDropdown.set([m2Min, m2Max]); if (perceelSliderDropdown) perceelSliderDropdown.set([perceelMin, perceelMax]);
        scale = 1; panX = 0; panY = 0; applyTransform(); applyFilters();
    }

    // More filters dropdown
    function openMoreFilters() {
        moreFiltersDropdown.classList.add('is-open'); moreFiltersBtn.classList.add('is-active');
        if (filterModelDropdown) filterModelDropdown.value = activeModelFilter;
        if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter;
        if (m2SliderDropdown) m2SliderDropdown.set(m2Range);
        if (perceelSliderDropdown) perceelSliderDropdown.set(perceelRange);
    }
    function closeMoreFilters() { moreFiltersDropdown.classList.remove('is-open'); moreFiltersBtn.classList.remove('is-active'); }
    moreFiltersBtn.addEventListener('click', (e) => { e.stopPropagation(); moreFiltersDropdown.classList.contains('is-open') ? closeMoreFilters() : openMoreFilters(); });
    document.addEventListener('click', (e) => { if (!moreFiltersDropdown.contains(e.target) && !moreFiltersBtn.contains(e.target)) closeMoreFilters(); });

    // Mobile filter drawer
    function openFilterDrawer() {
        filterDrawer.classList.add('is-open'); filterDrawerOverlay.classList.add('is-visible'); document.body.style.overflow = 'hidden';
        filterStatusMobile.value = activeStatusFilter; filterTypeMobile.value = activeTypeFilter; filterModelMobile.value = activeModelFilter; filterBedroomsMobile.value = activeBedroomsFilter;
        if (priceSliderMobile) priceSliderMobile.set(priceRange); if (m2SliderMobile) m2SliderMobile.set(m2Range); if (perceelSliderMobile) perceelSliderMobile.set(perceelRange);
    }
    function closeFilterDrawer() { filterDrawer.classList.remove('is-open'); filterDrawerOverlay.classList.remove('is-visible'); document.body.style.overflow = ''; }
    mobileFilterBtn.addEventListener('click', openFilterDrawer);
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
    filterDrawerOverlay.addEventListener('click', closeFilterDrawer);
    filterDrawerReset.addEventListener('click', () => { resetAllFilters(); closeFilterDrawer(); });
    filterDrawerApply.addEventListener('click', () => {
        activeStatusFilter = filterStatusMobile.value; activeTypeFilter = filterTypeMobile.value; activeModelFilter = filterModelMobile.value; activeBedroomsFilter = filterBedroomsMobile.value;
        if (priceSliderMobile) priceRange = priceSliderMobile.get().map(Number); if (m2SliderMobile) m2Range = m2SliderMobile.get().map(Number); if (perceelSliderMobile) perceelRange = perceelSliderMobile.get().map(Number);
        filterStatus.value = activeStatusFilter; filterType.value = activeTypeFilter; filterModel.value = activeModelFilter; filterBedrooms.value = activeBedroomsFilter;
        if (priceSlider) priceSlider.set(priceRange); if (m2Slider) m2Slider.set(m2Range); if (perceelSlider) perceelSlider.set(perceelRange);
        applyFilters(); closeFilterDrawer();
    });

    // View navigation
    function updateViewButtons() { viewPrev.disabled = currentViewIndex <= 0; viewNext.disabled = currentViewIndex >= views.length - 1; }
    viewSelect.addEventListener('change', () => { currentViewIndex = parseInt(viewSelect.value); renderView(currentViewIndex); updateViewButtons(); });
    viewPrev.addEventListener('click', () => { if (currentViewIndex > 0) { currentViewIndex--; viewSelect.value = currentViewIndex; renderView(currentViewIndex); updateViewButtons(); } });
    viewNext.addEventListener('click', () => { if (currentViewIndex < views.length - 1) { currentViewIndex++; viewSelect.value = currentViewIndex; renderView(currentViewIndex); updateViewButtons(); } });

    // Tooltip
    function showTooltip(el, cx, cy) {
        if (isOpen) return;
        const d = el.dataset;

        const r = wrapper.getBoundingClientRect();
        let x = cx - r.left + 15, y = cy - r.top + 15;
        if (x + 280 > r.width - 20) x = cx - r.left - 295;
        if (y + 240 > r.height - 20) y = cy - r.top - 255;
        tooltip.style.left = Math.max(10, x) + 'px';
        tooltip.style.top = Math.max(10, y) + 'px';

        tooltip.querySelector('.tooltip-image').src = d.afbeelding || '';
        const bn = tooltip.querySelector('.tooltip-bouwnummer');
        if (bn) {
            bn.textContent = d.bouwnummer ? 'Bouwnummer ' + d.bouwnummer : '';
            bn.style.display = d.bouwnummer ? 'block' : 'none';
        }
        tooltip.querySelector('.tooltip-title').textContent = d.naam || d.typewoning || '';
        tooltip.querySelector('.tooltip-badge').textContent = statusToLabel(d.status);
        tooltip.querySelector('.tooltip-badge').className = 'tooltip-badge ' + statusToTooltipBadge(d.status);
        tooltip.querySelector('.tooltip-price').textContent = d.prijs || '';
        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const specs = [];
        if (d.woonoppervlakte) specs.push(`<span class="tooltip-spec"><i class="fa fa-ruler-combined"></i> ${d.woonoppervlakte}</span>`);
        if (km) specs.push(`<span class="tooltip-spec"><i class="fa fa-bed"></i> ${km} slpk</span>`);
        tooltip.querySelector('.tooltip-specs').innerHTML = specs.join('');

        tooltip.style.display = 'block';
    }
    function hideTooltip() { tooltip.style.display = 'none'; }

    // Helper functie voor Chrome: vind hover-area onder muispositie
    function getHoverAreaAtPoint(clientX, clientY) {
        const elements = document.elementsFromPoint(clientX, clientY);
        return elements.find(el => el.classList && el.classList.contains('hover-area'));
    }

    let currentHoverEl = null;

    svg.addEventListener('mousemove', (e) => {
        if (isOpen) return;
        const el = getHoverAreaAtPoint(e.clientX, e.clientY);

        if (el !== currentHoverEl) {
            if (currentHoverEl) {
                currentHoverEl.classList.remove('is-hovering');
            }
            currentHoverEl = el;
            if (el && !el.classList.contains('is-dimmed')) {
                el.classList.add('is-hovering');
                svg.appendChild(el);
            }
        }

        if (!el || el.classList.contains('is-dimmed')) {
            hideTooltip();
            return;
        }
        showTooltip(el, e.clientX, e.clientY);
    });

    svg.addEventListener('mouseleave', () => {
        hideTooltip();
        if (currentHoverEl) {
            currentHoverEl.classList.remove('is-hovering');
            currentHoverEl = null;
        }
    });

    // Details panel
    function openPanel(el) {
        const d = el.dataset;
        svg.querySelectorAll('.hover-area.is-selected').forEach(p => p.classList.remove('is-selected'));
        el.classList.add('is-selected'); svg.classList.add('has-selection');
        document.getElementById('detailsType').textContent = d.naam || '';
        document.getElementById('detailsStatus').textContent = statusToLabel(d.status);
        document.getElementById('detailsStatus').className = 'badge ' + statusToBadgeClass(d.status);
        document.getElementById('detailsImage').src = d.afbeelding || '';
        document.getElementById('detailsTitle').textContent = d.bouwnummer ? 'Bouwnummer ' + d.bouwnummer : d.naam || '';
        document.getElementById('detailsPrice').textContent = d.prijs || '';
        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const m2Value = parseM2(d.woonoppervlakte) || '-';
        document.getElementById('detailsM2').textContent = m2Value;
        const m2Tag = document.getElementById('detailsM2').closest('.spec-tag');
        if (m2Tag) m2Tag.title = m2Value !== '-' ? m2Value + ' m² woonoppervlakte' : '';
        const slpkValue = km.replace(/[^\d]/g, '') || '-';
        document.getElementById('detailsSlaapkamers').textContent = slpkValue;
        const slpkTag = document.getElementById('detailsSlaapkamers').closest('.spec-tag');
        if (slpkTag) slpkTag.title = slpkValue !== '-' ? slpkValue + ' slaapkamer' + (slpkValue !== '1' ? 's' : '') : '';
        document.getElementById('detailsBouwtype').textContent = d.naam || '';
        document.getElementById('detailsVerdieping').textContent = d.verdieping ? (d.verdieping === '0' ? 'Begane grond' : d.verdieping + 'e') : '-';
        document.getElementById('detailsBuitenruimte').textContent = d.buitenruimte ? d.buitenruimte + ' m²' : '-';
        document.getElementById('detailsLigging').textContent = d.ligging || '-';
        const verdiepingDd = document.getElementById('detailsVerdieping');
        const buitenruimteDd = document.getElementById('detailsBuitenruimte');
        const liggingDd = document.getElementById('detailsLigging');
        verdiepingDd.style.display = d.verdieping ? '' : 'none';
        if (verdiepingDd.previousElementSibling) verdiepingDd.previousElementSibling.style.display = d.verdieping ? '' : 'none';
        buitenruimteDd.style.display = d.buitenruimte ? '' : 'none';
        if (buitenruimteDd.previousElementSibling) buitenruimteDd.previousElementSibling.style.display = d.buitenruimte ? '' : 'none';
        liggingDd.style.display = d.ligging ? '' : 'none';
        if (liggingDd.previousElementSibling) liggingDd.previousElementSibling.style.display = d.ligging ? '' : 'none';
        document.getElementById('detailsInschrijven').href = d.info || '#';
        document.getElementById('detailsInfo').href = d.info || '#';
        panel.classList.add('is-open'); isOpen = true; pinnedId = d.id; hideTooltip();
    }
    function closePanel() {
        panel.classList.remove('is-open'); isOpen = false; pinnedId = null;
        svg.querySelectorAll('.hover-area.is-selected').forEach(p => p.classList.remove('is-selected')); svg.classList.remove('has-selection');
    }
    svg.addEventListener('click', (e) => {
        const el = getHoverAreaAtPoint(e.clientX, e.clientY);
        if (!el || el.classList.contains('is-dimmed')) return;
        if (el.classList.contains('is-selected')) { closePanel(); } else { openPanel(el); }
    });
    svg.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const el = e.target.closest('.hover-area');
        if (!el || el.classList.contains('is-dimmed')) return;
        e.preventDefault();
        if (el.classList.contains('is-selected')) { closePanel(); } else { openPanel(el); }
    });
    document.getElementById('detailsClose').addEventListener('click', closePanel);
    overlayBg.addEventListener('click', closePanel);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });

    // Zoom & pan
    function applyTransform() { const t = `matrix(${scale},0,0,${scale},${panX},${panY})`; bgImg.style.transform = t; svg.style.transform = t; wrapper.classList.toggle('draggable', scale > 1 && !isOpen); }
    function constrainPan() { const vw = wrapper.clientWidth, vh = wrapper.clientHeight, cw = vw * scale, ch = vh * scale; panX = Math.max(Math.min(0, vw - cw), Math.min(panX, 0)); panY = Math.max(Math.min(0, vh - ch), Math.min(panY, 0)); }
    function zoomAt(cx, cy, f) {
        if (isOpen) return; hideTooltip();
        const r = wrapper.getBoundingClientRect(), px = (cx - r.left - panX) / scale, py = (cy - r.top - panY) / scale;
        const ns = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale * f)); if (ns === scale) return;
        scale = ns; panX = cx - r.left - px * scale; panY = cy - r.top - py * scale; constrainPan(); applyTransform();
    }
    document.querySelector('.zoom-controls').addEventListener('click', (e) => {
        const btn = e.target.closest('button'); if (!btn || btn.id === 'toggleOverlay') return;
        const a = btn.dataset.zoom, r = wrapper.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        if (a === 'in') zoomAt(cx, cy, 1.3); if (a === 'out') zoomAt(cx, cy, 1 / 1.3); if (a === 'reset') { scale = 1; panX = 0; panY = 0; applyTransform(); }
    });
    wrapper.addEventListener('wheel', (e) => {
        if (isOpen) return;
        if (!e.ctrlKey) return;
        e.preventDefault();
        zoomAt(e.clientX, e.clientY, e.deltaY < 0 ? 1.1 : 1 / 1.1);
    }, { passive: false });
    wrapper.addEventListener('pointerdown', (e) => {
        if (isOpen || e.target.closest('button, select') || scale <= 1) return; hideTooltip(); wrapper.classList.add('panning');
        let lx = e.clientX, ly = e.clientY;
        const onMove = (ev) => { panX += ev.clientX - lx; panY += ev.clientY - ly; lx = ev.clientX; ly = ev.clientY; constrainPan(); applyTransform(); };
        const onUp = () => { wrapper.classList.remove('panning'); window.removeEventListener('pointermove', onMove); window.removeEventListener('pointerup', onUp); };
        window.addEventListener('pointermove', onMove); window.addEventListener('pointerup', onUp);
    });

    // Toggle overlay
    document.getElementById('toggleOverlay').addEventListener('click', function() { const h = svg.style.display === 'none'; svg.style.display = h ? '' : 'none'; this.querySelector('i').className = h ? 'fa fa-eye' : 'fa fa-eye-slash'; });

    // URL params
    function updateUrlParams() {
        const p = new URLSearchParams();
        if (activeStatusFilter) p.set('status', activeStatusFilter); if (activeTypeFilter) p.set('type', activeTypeFilter);
        if (activeModelFilter) p.set('model', activeModelFilter); if (activeBedroomsFilter) p.set('slaapkamers', activeBedroomsFilter);
        if (filterConfig.showPriceFilter && (priceRange[0] > priceMin || priceRange[1] < priceMax)) p.set('prijs', priceRange[0] + '-' + priceRange[1]);
        if (filterConfig.showM2Filter && (m2Range[0] > m2Min || m2Range[1] < m2Max)) p.set('woonopp', m2Range[0] + '-' + m2Range[1]);
        if (filterConfig.showPerceelFilter && (perceelRange[0] > perceelMin || perceelRange[1] < perceelMax)) p.set('perceel', perceelRange[0] + '-' + perceelRange[1]);
        if (activeView === 'list') p.set('weergave', 'lijst');
        window.history.replaceState({}, '', p.toString() ? window.location.pathname + '?' + p.toString() : window.location.pathname);
    }
    function readUrlParams() {
        const p = new URLSearchParams(window.location.search);
        const st = p.get('status'); if (st && kavelData.statuses.includes(st)) { activeStatusFilter = st; filterStatus.value = st; filterStatusMobile.value = st; }
        const ty = p.get('type'); if (ty && kavelData.types.map(t => t.toLowerCase()).includes(ty.toLowerCase())) { activeTypeFilter = ty.toLowerCase(); filterType.value = ty.toLowerCase(); filterTypeMobile.value = ty.toLowerCase(); }
        const mo = p.get('model'); if (mo && kavelData.models.includes(mo)) { activeModelFilter = mo; filterModel.value = mo; filterModelMobile.value = mo; }
        const sl = p.get('slaapkamers'); if (sl && kavelData.bedrooms.includes(sl)) { activeBedroomsFilter = sl; filterBedrooms.value = sl; filterBedroomsMobile.value = sl; }
        const pr = p.get('prijs'); if (pr && pr.includes('-')) { const [mn, mx] = pr.split('-').map(Number); if (!isNaN(mn) && !isNaN(mx) && mn >= priceMin && mx <= priceMax) { priceRange = [mn, mx]; if (priceSlider) priceSlider.set(priceRange); if (priceSliderMobile) priceSliderMobile.set(priceRange); } }
        const wo = p.get('woonopp'); if (wo && wo.includes('-')) { const [mn, mx] = wo.split('-').map(Number); if (!isNaN(mn) && !isNaN(mx) && mn >= m2Min && mx <= m2Max) { m2Range = [mn, mx]; if (m2Slider) m2Slider.set(m2Range); if (m2SliderMobile) m2SliderMobile.set(m2Range); } }
        const pe = p.get('perceel'); if (pe && pe.includes('-')) { const [mn, mx] = pe.split('-').map(Number); if (!isNaN(mn) && !isNaN(mx) && mn >= perceelMin && mx <= perceelMax) { perceelRange = [mn, mx]; if (perceelSlider) perceelSlider.set(perceelRange); if (perceelSliderMobile) perceelSliderMobile.set(perceelRange); } }
        if (p.get('weergave') === 'lijst') setActiveView('list');
    }

    // Init
    renderView(0); renderPricelist(); readUrlParams(); applyFilters(); updateViewButtons(); isInitialized = true;
})();